import axios from 'axios';

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8000',
  timeout: 30000,
});

// Attach token to every request
API.interceptors.request.use(config => {
  const token = localStorage.getItem('cia_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 — redirect to login
API.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      localStorage.removeItem('cia_token');
      localStorage.removeItem('cia_customer');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Calls
export const getCalls = () => API.get('/calls/list');
export const getLatestCall = () => API.get('/calls/latest');
export const transcribeCall = (id) => API.post(`/calls/transcribe/${id}`);
export const classifyCall = (id) => API.post(`/calls/classify/${id}`);
export const runPipeline = (id) => API.post(`/calls/pipeline/${id}`);

// Contacts
export const getContacts = (stage, search) => {
  const params = {};
  if (stage) params.stage = stage;
  if (search) params.search = search;
  return API.get('/contacts/', { params });
};
export const getContact = (id) => API.get(`/contacts/${id}`);
export const getPipelineSummary = () => API.get('/contacts/pipeline');
export const getFollowUps = () => API.get('/contacts/followups');
export const updatePipeline = (id, stage) => API.patch(`/contacts/${id}/pipeline`, { stage });
export const updateNotes = (id, notes) => API.patch(`/contacts/${id}/notes`, { notes });
export const setFollowUp = (id, date) => API.patch(`/contacts/${id}/followup`, { follow_up_date: date });

// Health
export const getHealth = () => API.get('/health');

// Auth
export const getCurrentCustomer = () => API.get('/auth/me');

export default API;
